/* eslint import/prefer-default-export:0 */
export const EMIT_CLEAN_SLATE = 'EMIT_CLEAN_SLATE';
